import { SendMoneyService } from './../../_services/sendmoneyservice/sendmoneyservice';
import { SendMoneyDetail } from './../../models/sendmoney/sendmoney';
import { Component, OnInit } from '@angular/core';
import { dashboardlandingpageservice } from '../../_services/dashboardservice/dash-board.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { UserStateService } from '../../_services/userservice/userstateservice';
import { CountryDetail } from '../../sharedcomponents/_common/countrylist/countryinformation';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { AuthService } from '../../_services/userservice/auth.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateService } from 'ng2-translate/ng2-translate';
@Component({
  selector: 'app-dashboard-exchangerate',
  templateUrl: './dashboard-exchangerate.component.html',
  styleUrls: ['./dashboard-exchangerate.component.css'],
  providers: [dashboardlandingpageservice, CountryService, AlertService, AuthService, utilityService]
})
export class DashboardExchangerateComponent implements OnInit {
  public currencyexchangemodel: any = {};
  exchangerate: number;
  userprefCountry: string;
  countrycollection = new Array<CountryDetail>();
  appSettings: any;
  srcCountryImage: any;
  destCountryImage: any;
  imagedata: any;
  userDetail: usercommonattribute;
  sendMoneyDetail: SendMoneyDetail;
  constructor(
    private dashboardserv: dashboardlandingpageservice,
    private countryserv: CountryService,
    public utilityServ: utilityService,
    private userStateService: UserStateService,
    public domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private alertService: AlertService,
    private sendMoneyService: SendMoneyService,
    private auth: AuthService
  ) {
    this.userDetail = new usercommonattribute();

    if (sessionStorage.UserData != undefined) {
      let UserData = JSON.parse(
        this.utilityServ.AESDecrypt(sessionStorage.UserData)
      );
      this.auth.setUserDetails(UserData);
    }
    const userStateServiceSub = this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.userprefCountry = data.countryPreference;
      this.userDetail = data;
    });


    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    if (this.sendMoneyDetail.agentDetails.CountryTo != '') {
      this.userprefCountry = this.sendMoneyDetail.agentDetails.CountryTo;
    }

    this.appSettings = AppSettings;
  }

  ngOnInit() {
    // if (sessionStorage.UserData == undefined || sessionStorage.UserData == 'undefined' || sessionStorage.UserData == '' || sessionStorage.UserData == null) {
    //   this.userDetails();
    // }else{}

    if (this.userDetail.countryPreference != '' && this.userDetail.countryPreference != undefined) {
      this.loadCountryImageFile();
      this.callexchangerateservice();
    } else {
      this.userDetails();
    }
  }

  userDetails() {
    this.utilityServ.busy = this.auth.getUserDetail().subscribe(
      data => {
        const resJSON = data;
        if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == 20001) {
          return false;
        }
        if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          this.auth.setUserDetails(resJSON);
          sessionStorage.UserData = this.utilityServ.AESEncrypt(JSON.stringify(resJSON));
          this.loadCountryImageFile();
          this.callexchangerateservice();
        } else {
          this.alertService.openErrorAlert('Common_lblOops', resJSON.Envelope.Body.CustomerInfoResponse.StatusCode + ' - ' + resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
        }
      },
      error => {}
    );
  }

  loadCountryImageFile() {
    this.utilityServ.getCountryImage(AppSettings.BaseCountry).subscribe(
      res => {
        this.srcCountryImage = res;
      },
      error => {}
    );
    this.utilityServ.getCountryImage(this.userprefCountry).subscribe(
      res => {
        this.destCountryImage = res;
      },
      error => {}
    );
  }
  getexchangerate() {
    this.utilityServ.busy = this.dashboardserv.getexchangerateservice(this.currencyexchangemodel).subscribe(
      data => {
        if (data.StatusCode == 20001) {
          return false;
        }
        if (data.StatusCode === enumStatusCodeList.SUCCESS) {
          this.exchangerate = data.ExchangeRate;
        }
      },
      error => {}
    );
  }
  callexchangerateservice() {
    this.countrycollection = this.countryserv.getCountryListFromLocale();

    if (this.userprefCountry === undefined) {
      //console.log('Preferd Country Not Found');
      return;
    }

    let countryCurrencyCode = [];
    let conList = this.countrycollection.filter(item => item.CountryCode === this.userprefCountry);
    if (conList.length > 0) {
      countryCurrencyCode = this.utilityServ.getArray(conList[0].CountryCurrencyCode).filter(item => item.CountryCurrencyCode !== AppSettings.BaseCountryCurrency);
    }
    if (countryCurrencyCode.length > 0) {
      this.intializeexchangemodel(this.userprefCountry, countryCurrencyCode[0].CurrencyCode);
    }
  }

  intializeexchangemodel(countryPreference, CurrencyCodeTo) {
    this.currencyexchangemodel.CountryCodeFrom = AppSettings.BaseCountry;
    this.currencyexchangemodel.CountryCodeTo = countryPreference;

    this.currencyexchangemodel.CurrencyCodeFrom = AppSettings.BaseCountryCurrency;
    this.currencyexchangemodel.CurrencyCodeTo = CurrencyCodeTo; // PreferCountryCode

    this.currencyexchangemodel.DeliveryMethod = '1';
    this.currencyexchangemodel.ProgramId = '0';

    this.getexchangerate();
  }

  errorHandler(event) {
    event.currentTarget.style.display = 'none';
    //event.currentTarget.src = 'assets/images/round_emty.png';
  }
}



// WEBPACK FOOTER //
// ./src/app/dash-board/dashboard-exchangerate/dashboard-exchangerate.component.ts